import { GeneralSetting } from '@apis/index'
import Button from '@components/button'
import Fields from '@components/fields'
import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import {
  BannerContainer,
  Title,
  ToggleContainer,
  ToggleButton,
  FormContainer,
  FieldWrapper,
  SubmitButton,
} from './style'
import DeleteBanner from './DeleteBanner'

const BannerManagement = () => {
  const [loading, setLoading] = useState(false)
  const [toggleBannerType, setToggleBannerType] = useState('Header')
  const initialValues = {
    file: {
      base64: '',
      extension: '',
    },
  }

  const handleToggle = (type: any) => {
    setToggleBannerType(type)
  }

  const submitHandler = async (values: any, { resetForm }) => {
    setLoading(true)
    const payload = {
      group: 'banner-list',
      key: `banner-${Date.now()}`,
      value: `This is ${toggleBannerType} Banner Data`,
      title: 'Trial',
      type: toggleBannerType,
      file: {
        extension: values?.file?.extension,
        base64: values?.file?.base64,
      },
    }

    await GeneralSetting.create('generalSettings', payload)
      .then(() => {
        resetForm()
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <BannerContainer style={{ marginTop: '40px' }}>
      <Title>Add New Banner</Title>

      <ToggleContainer>
        <ToggleButton
          active={toggleBannerType === 'Header'}
          onClick={() => handleToggle('Header')}
        >
          Header Banner
        </ToggleButton>
        <ToggleButton
          active={toggleBannerType === 'Footer'}
          onClick={() => handleToggle('Footer')}
        >
          Footer Banner
        </ToggleButton>
      </ToggleContainer>

      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit} encType="multipart/form-data">
            <FormContainer>
              <FieldWrapper>
                <Fields.Upload
                  name="file"
                  label={`${toggleBannerType} Banner Image`}
                  varient="dashed"
                />
              </FieldWrapper>

              <SubmitButton>
                <Button
                  title={`Add ${toggleBannerType} Banner`}
                  type="submit"
                  loading={loading}
                  styleButton="width: fit-content; "
                />
              </SubmitButton>
            </FormContainer>
          </Form>
        )}
      </Formik>
      <DeleteBanner toggleBannerType={toggleBannerType} />
    </BannerContainer>
  )
}

export default BannerManagement
